import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectCurrentId } from '@gandi/redux-sharing';
import { useTranslator, mapTags } from '@gandi/translate';
import { Base, Switch, Heading, HeadingIcon, Text } from '@gandi/ui';
import { usePrepaid } from '../hooks';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export default function FlushPrepaidCheckbox({
  totalToPay,
  onChange,
  context
}) {
  const {
    __,
    formatPrice
  } = useTranslator();
  const sharingId = useSelector(selectCurrentId);
  const prepaid = usePrepaid({
    sharingId
  });
  if (!prepaid) return null;
  const {
    amount,
    currency
  } = prepaid;
  const handleChange = evt => {
    return onChange(evt.target.checked);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Heading, {
      fontSize: "s",
      marginBottom: "xsmall",
      children: [/*#__PURE__*/_jsx(HeadingIcon, {
        name: "prepaid",
        slot: "iconStart"
      }), __('Prepaid account')]
    }), /*#__PURE__*/_jsx(Base, {
      tagName: "p",
      marginTop: "none",
      marginBottom: "xsmall",
      children: mapTags(__('You currently have [[prepaidAmount:]] on your prepaid account, ' + 'which is not enought to pay this [[invoiceAmount:]] order.'), () => ({
        prepaidAmount: /*#__PURE__*/_jsx(Text, {
          weight: "semibold",
          children: formatPrice(amount, currency)
        }),
        invoiceAmount: /*#__PURE__*/_jsx(Text, {
          weight: "semibold",
          children: formatPrice(totalToPay, currency)
        })
      }))
    }), /*#__PURE__*/_jsx(Switch, {
      name: "flush-prepaid",
      onClick: handleChange,
      checked: context === 'flush',
      marginBottom: "base",
      children: __('Flush your prepaid account and complete with one of the method below')
    })]
  });
}